import { render, staticRenderFns } from "./JobBoardPartnerLink.vue?vue&type=template&id=7156d3f6"
import script from "./JobBoardPartnerLink.vue?vue&type=script&lang=ts"
export * from "./JobBoardPartnerLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports